/**
 * TabsContextProvider - контекст провайдер для TabsStore
 */

import { Tabs as TabsAntd } from 'antd'
import { createContext, useContext } from 'react'
import { configManager } from '../../Managers/Config'
import { EventManager } from '../../Managers/Event/EventManager'
import { MergeConfigAndPropsTask } from '../../Tasks/Utils/MergeConfigAndPropsTask'
import { TabsStore } from './Stores/TabsStore'

export const TabsContext = createContext<TabsStore | null>(null)

/**
 * Створює новий TabsStore з заданою конфігурацією
 */
export const createTabsContext = (props: any = {}): TabsStore => {
    // Отримуємо конфігурацію Tabs
    const tabsConfig = configManager.get('TabsConfig', {})
    
    // Об'єднуємо конфігурацію з пропсами через MergeConfigAndPropsTask
    const mergedProps = MergeConfigAndPropsTask({
        tabsConfig,
        tabsProps: props,
    }) || props
    
    // Встановлюємо шаблон за замовчуванням
    if (!mergedProps.template) {
        mergedProps.template = TabsAntd
    }
    
    if( mergedProps.isObservable === undefined ) {
        mergedProps.isObservable = true
    }

    // Створюємо тимчасовий eventManager для виконання onBeforeInit
    const tempEventManager = new EventManager()
    
    // Виконуємо всі onBeforeInit події з переданих пропсів
    if (mergedProps.eventHandlers?.onBeforeInit) {
        Object.entries(mergedProps.eventHandlers.onBeforeInit).forEach(([name, handler]) => {
            tempEventManager.on('onBeforeInit', name, handler as any)
        })
    }
    
    // Emit onBeforeInit події - передаємо props по ссылці для можливості змін
    tempEventManager.emit('onBeforeInit', { props: mergedProps })
    
    // Створюємо екземпляр TabsStore
    const tabsContext = new TabsStore(mergedProps)
    
    // Виконуємо onAfterInit події з eventManager створеного екземпляра
    tabsContext.getEventManager().emit('onAfterInit', { tabsContext })
    
    return tabsContext
}

/**
 * Хук для отримання TabsContext
 */
export const useTabsContext = (): TabsStore | null => {
    const context = useContext(TabsContext)
    return context
}

/**
 * Provider компонент для TabsContext
 */
export const TabsContextProvider = TabsContext.Provider
